import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootLabel: {
        '&:focused': {
            color: 'red',
        },
    },
    rootGridHead: {
        width: '100%',
    },
    outlineSelect: {
        paddingLeft: '45px',
        margin: '0',
        width: '70%',
        '& > .MuiOutlinedInput-root.Mui-focused > .MuiOutlinedInput-notchedOutline': {
            borderColor: "#3f51b5 !important",
        },
        '& > label': {
            left: '44px',
        },
        '@media (max-width: 1060px)': {
            width: '49%',
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0px',
            width: '100%',
            '& > label': {
                left: '0px',
            }
        },
    },
    rootProfile: {
        padding: '0px 10px 0px 10px'
    },
    focused: {
        color: '#3f51b5 !important',
    },
    
    rootButtonCancel: {
        width: '150px',
        height: '50px',
        borderColor: '#098EAC',
        borderRadius: '5px',
        marginRight: '5px',
        color: '#098EAC',
        textTransform: 'capitalize',
        fontSize: '18px',
        fontFamily: themeCommon.RobotoBold,
        [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            width: '160px',
            height: '45px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            width: '150px',
            height: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '13px',
            width: '140px',
            height: '40px',
        },
    },
    rootButtonOk: {
        width: '150px',
        height: '50px',
        backgroundColor: '#098EAC',
        borderRadius: '5px',
        color: 'white',
        marginLeft: '5px',
        textTransform: 'capitalize',
        fontSize: '18px',
        fontFamily: themeCommon.RobotoBold,
        [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            width: '160px',
            height: '45px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            width: '150px',
            height: '40px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '13px',
            width: '140px',
            height: '40px',
        },
        '&:hover': {
            backgroundColor: '#0492C2'
        } 
    },
    disabledButton: {
        backgroundColor: 'rgba(9,142,172,0.8)'
    },
    rootInfo:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '135px',
        [theme.breakpoints.down('md')]: {
            marginTop: '85px',
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '70px',
        },
    },
    rootNicknameTextfield: {
        maxWidth: '360px',
        paddingRight: theme.spacing(1),
    },
    rootNameTextfield: {
        paddingLeft: theme.spacing(1),
        maxWidth: '360px',
    },
    rootEmailTextfield: {
        maxWidth: '720px',
        margin: '30px 0',
        [theme.breakpoints.down('md')]: {
            margin: '25px 0',
        },
        [theme.breakpoints.down('xs')]: {
            margin: '20px 0',
        },
    },
    rootChart: {
        position: 'relative',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
        padding: '16px 16px 50px 16px ',
        marginBottom: '80px',
        [theme.breakpoints.down('md')]: {
            padding: '16px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '10px 16px',
            position: 'unset',
        },
    },
    resizeText: {
        [theme.breakpoints.down('md')]: {
            '& > div': {
                height: '45px',
            },
            '& > div > input': {
                fontSize: themeCommon.fontSize15px,
            }
        },
        [theme.breakpoints.down('xs')]: {
            '& > div': {
                height: '40px',
            },
            '& > div >input': {
                fontSize: themeCommon.fontSize14px,
            }
        },
    },
    rootSelect: {
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize15px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize14px,
        },
    },
    chart: {
        '& > canvas': {
            width: '95% !important',
            height: '692px !important'
        },
        '@media (max-width: 1400px)': {
            '& > canvas': {
                height: '550px !important'
            },
        },
        [theme.breakpoints.down('md')]: {
            '& > canvas': {
                height: '500px !important'
            },
        },
        [theme.breakpoints.down('sm')]: {
            '& > canvas': {
                width: '95% !important',
                height: '440px !important'
            },
        },
    },
    rootDatePicker: {
        width: '29%',
        flexBasis: 'unset',
        zIndex: 100,
        '@media (max-width: 1060px)': {
            width: '49%',
            maxWidth: 'unset'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '10px',
            width: '100%',
            maxWidth: 'unset'
        },
    },
    rootSelectBox: {
        width: '35%',
        flexBasis: 'unset',
        '@media (max-width: 1060px)': {
            width: '60%',
            maxWidth: 'unset'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '10px',
            width: '100%',
            maxWidth: 'unset'
        },
    },
    datePicker: {
        height: '55px',
        border: 'none',
        fontSize: '16px',
        width: '100%',
        margin: '0',
        paddingLeft: '10px',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        '&::placeholder': {
            color: '#D7D7D7',
        },
        '&:focus': {
            outline: 'none',
        },
        [theme.breakpoints.down('md')]: {
            height: '45px',
            fontSize: themeCommon.fontSize15px,
        },
        [theme.breakpoints.down('xs')]: {
            height: '40px',
            fontSize: themeCommon.fontSize14px,
        },
    },
    labelTimePicker: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '1px solid #D7D7D7',
        borderRadius: '4px',
        '& .react-datepicker-popper': {
            zIndex: 2,
        },
        '& > .react-datepicker-wrapper': {
            width: '100%',
        }
    },
    icon:{
        background: '#E9ECEF',
        borderBottomRightRadius: '4px',
        borderTopRightRadius: '4px',
        height: '55px',
        width: '65px',
        justifyContent: 'center',
        display: 'flex',
        '@media (max-width: 1060px)': {
            width: '55px',
        },
        [theme.breakpoints.down('md')]: {
            height: '45px',
            fontSize: themeCommon.fontSize15px,
            '& > svg': {
                width: '23px'
            }
        },
        [theme.breakpoints.down('sm')]: {
            '& > svg': {
                width: '23px'
            }
        },
        [theme.breakpoints.down('xs')]: {
            height: '40px',
            fontSize: themeCommon.fontSize14px,
            '& > svg': {
                width: '20px'
            }
        },
    },
    iconDatePicker: {
        zIndex: 1,
        height: '55px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            height: '45px',
        },
        [theme.breakpoints.down('xs')]: {
            height: '40px',
        },
    },
    customCelendar: {
        border: 'unset',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '5px',
        // css for picker month
        '& .react-datepicker__month-container': {
            padding: '10px',
            '& .react-datepicker__header': {
                backgroundColor: '#FFFFFF',
                borderBottom: 'unset',
                '& .react-datepicker__day-names': {
                    display: 'flex',
                    justifyContent: 'center',
                    '& .react-datepicker__day-name': {
                        margin: '0px',
                        width: '40px',
                        height: '36px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '0px',
                    }
                },
            },
            '& .react-datepicker__month': {
                // css for picker month
                '& .react-datepicker__month-wrapper': {
                    display: 'flex',
                    '& .react-datepicker__month-text': {
                        margin: '0px',
                        width: '70px',
                        height: '56px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '0px',
                    },
                    '& .react-datepicker__month--in-range': {
                        background: '#62C5DA',
                        color: '#000000',
                    },
                    '& .react-datepicker__month--range-start': {
                        background: themeCommon.lightBlue,
                        borderRadius: '10px 0px 0px 10px',
                    },
                    '& .react-datepicker__month--range-end': {
                        background: themeCommon.lightBlue,
                        borderRadius: '0px 10px 10px 0px;',
                    },
                    '& .react-datepicker__month-text--keyboard-selected': {
                        background: themeCommon.lightBlue,
                    }
                },
                // css for picker days
                '& .react-datepicker__week': {
                    display: 'flex',
                    '& .react-datepicker__day': {
                        margin: '0px',
                        width: '40px',
                        height: '36px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '0px',
                        // background: 'white',
                        // color: '#000',
                    },
                    '& .react-datepicker__day--in-range': {
                        background: '#62C5DA',
                        color: '#000000',
                    },
                    '& .react-datepicker__day--keyboard-selected.react-datepicker__day--in-range': {
                        background: '#62C5DA',
                        color: '#000000',
                    },
                    '& .react-datepicker__day--range-start': {
                        background: themeCommon.lightBlue,
                        borderRadius: '10px 0px 0px 10px',
                        color: '#FFFFFF',
                    },
                    '& .react-datepicker__day--range-end': {
                        background: themeCommon.lightBlue,
                        borderRadius: '0px 10px 10px 0px',
                        color: '#FFFFFF',
                    },
                    '& .react-datepicker__day--selected': {
                        background: themeCommon.lightBlue,
                    },
                    '& .react-datepicker__day--keyboard-selected': {
                        background: themeCommon.lightBlue,
                    },
                    '& .react-datepicker__day--range-start.react-datepicker__day--range-end': {
                        borderRadius: '10px 10px 10px 10px',
                    }
                }
            }
        },
        // css for picker year
        '& .react-datepicker__year--container': {
            padding: '10px',
            '& .react-datepicker__header': {
                backgroundColor: '#FFFFFF',
                borderBottom: 'unset',
            },
            '& .react-datepicker__year': {
                // display: 'flex',
                '& .react-datepicker__year-wrapper': {
                    // display: 'flex',
                    width: '285px',
                    maxWidth: 'unset',
                    '& .react-datepicker__year-text': {
                        margin: '0px',
                        width: '70px',
                        height: '56px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '0px',
                    },
                    '& .react-datepicker__year--in-range': {
                        background: '#62C5DA',
                        color: '#000000',
                    },
                    '& .react-datepicker__year--range-start': {
                        background: themeCommon.lightBlue,
                        borderRadius: '10px 0px 0px 10px',
                    },
                    '& .react-datepicker__year--range-end': {
                        background: themeCommon.lightBlue,
                        borderRadius: '0px 10px 10px 0px;',
                    },
                    '& .react-datepicker__year-text--keyboard-selected': {
                        background: themeCommon.lightBlue,
                    }
                }
            }
        }
    },
}))

export default useStyles